import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { BreadCrumb, PreviewCardHeader } from '../../../../Common'
import { Container } from 'reactstrap'

import AddPartnerForm from './Components/Form'

const AddPartner = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  /* ---------------------------- SUBMIT HANDLER ---------------------------- */
  const submitHandler = (data) => {
    console.log('main', data)
  }

  /* ---------------------------- BREADCRUM HANDLER ---------------------------- */
  const breadcrumNavigationHandler = (title) => {
    console.log({ title })
    if (title === `Dashboard`) {
      history.push('/dashboard')
    } else if (title === `Add Category`) {
      // do nothing
    } else if (title === `Category`) {
      // do nothing
    }
  }

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <>
          <BreadCrumb
            title="Partner"
            navigationby={breadcrumNavigationHandler}
            navigation={['Dashboard', 'Patner', 'Add Partner']}
          />
          <AddPartnerForm onSubmit={submitHandler} />
        </>
      </Container>
    </div>
  )
}

export default AddPartner
